import { render, staticRenderFns } from "./orderIcbcList.vue?vue&type=template&id=03f054a0&scoped=true"
import script from "./orderIcbcList.vue?vue&type=script&lang=js"
export * from "./orderIcbcList.vue?vue&type=script&lang=js"
import style0 from "./orderIcbcList.vue?vue&type=style&index=0&id=03f054a0&prod&scoped=true&lang=css"
import style1 from "./orderIcbcList.vue?vue&type=style&index=1&id=03f054a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f054a0",
  null
  
)

export default component.exports